import { PLAYER_VEHICLES, type PlayerVehicleId } from '../../content/playerVehicles';
import { el } from '../components/el';

/** One button per player vehicle: Sprinter, Toyota "Fish", Toyota Vitz. */
export function createVehiclePicker(onPick: (id: PlayerVehicleId) => void): { root: HTMLElement; select: (id: PlayerVehicleId) => void } {
  const root = el('div', 'vehicle-picker');
  const buttons = new Map<PlayerVehicleId, HTMLButtonElement>();
  for (const vehicle of Object.values(PLAYER_VEHICLES)) {
    const button = el('button', 'vehicle-option');
    button.append(el('strong', '', vehicle.name), el('small', '', vehicle.blurb));
    button.addEventListener('click', () => {
      select(vehicle.id);
      onPick(vehicle.id);
    });
    buttons.set(vehicle.id, button);
    root.append(button);
  }
  const select = (id: PlayerVehicleId): void => buttons.forEach((b, key) => b.classList.toggle('selected', key === id));
  return { root, select };
}
